import { createApiCall } from 'lib/base';

const POST_INVESTCORE_EMPLOYEE_PROGRAM_VESTING_API_ID =
  'DASHBOARD/POST_INVESTCORE_EMPLOYEE_PROGRAM_VESTING_API_ID';

const apiCall = createApiCall(
  POST_INVESTCORE_EMPLOYEE_PROGRAM_VESTING_API_ID,
  ({ id, force }) => ({
    endpoint: `/api/admin/employee-programs/${id}/vesting`,
    method: 'POST',
    body: force ? { force: true } : undefined,
    isStay: true,
    notify: true,
  })
);

export default apiCall;
